import React from 'react';

const BRAND = '#d0142d';

const SKELETON_CSS = `
@keyframes skPulse {
  0%   { opacity: 0.5; }
  50%  { opacity: 1; }
  100% { opacity: 0.5; }
}
.sk {
  display: block;
  background-color: rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  animation: skPulse 1.4s ease-in-out infinite;
  flex: 0 0 auto;
}
.sk-light {
  background-color: rgba(255, 255, 255, 0.3);
}
.sk-circle {
  border-radius: 50%;
}
`;

/** Wstrzykiwane raz, na górze strony głównej. */
export function SkeletonStyles() {
  return <style>{SKELETON_CSS}</style>;
}

const H2_DARK = {
  color: 'rgb(30,30,30)',
  fontSize: '23px',
  fontWeight: 'bold',
  textAlign: 'center',
  width: 'auto',
};

const HR = { border: `2px solid ${BRAND}`, width: '80%', borderRadius: '10px' };

// ── LICZBY ───────────────────────────────────────────────────────────────────

export function StatsSkeleton() {
  return (
    <section
      className="recordSection"
      aria-hidden="true"
      style={{ display: 'flex', width: '92%', marginTop: '-10px', maxWidth: '1000px' }}
    >
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          className="recordSection_panel"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: BRAND,
            borderRadius: '8px',
            gap: '7px',
          }}
        >
          <span className="sk sk-light sk-circle" style={{ width: '26px', height: '26px' }} />
          <span className="sk sk-light" style={{ width: '42px', height: '9px' }} />
          <span className="sk sk-light" style={{ width: '68px', height: '21px' }} />
          <span className="sk sk-light" style={{ width: '92px', height: '9px' }} />
        </div>
      ))}
    </section>
  );
}

// ── DYSCYPLINY ───────────────────────────────────────────────────────────────

export function DisciplinesSkeleton() {
  return (
    <section
      aria-hidden="true"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        gap: '10px',
        backgroundColor: BRAND,
        paddingBottom: '50px',
      }}
    >
      <h2
        style={{
          color: 'rgb(250,250,250)',
          fontSize: '23px',
          fontWeight: 'bold',
          marginTop: '35px',
          textAlign: 'center',
          width: 'auto',
        }}
      >
        Poznaj zajęcia dla siebie!
      </h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '90%',
          marginTop: '20px',
          flexWrap: 'wrap',
          gap: '30px',
        }}
      >
        {Array.from({ length: 18 }).map((_, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px',
              width: '80px',
            }}
          >
            <span className="sk sk-light sk-circle" style={{ width: '70px', height: '70px' }} />
            <span className="sk sk-light" style={{ width: '66px', height: '9px' }} />
            <span className="sk sk-light" style={{ width: '42px', height: '9px' }} />
          </div>
        ))}
      </div>
    </section>
  );
}

// ── OPINIE ───────────────────────────────────────────────────────────────────

export function TestimonialsSkeleton() {
  return (
    <>
      <h2 style={{ ...H2_DARK, marginBottom: '-15px', marginTop: '10px' }}>
        Opinie naszych klientów!
      </h2>
      <section
        className="qouteSection"
        aria-hidden="true"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '30px',
          overflowX: 'auto',
          flexWrap: 'nowrap',
          paddingBottom: '40px',
          maxWidth: '1200px',
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              flex: '0 0 300px',
              height: '370px',
              border: `2px solid ${BRAND}`,
              borderRadius: '10px',
              backgroundColor: 'rgba(255,255,255,0.45)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '11px',
              padding: '26px 22px',
            }}
          >
            <span className="sk" style={{ width: '32px', height: '20px', marginBottom: '14px' }} />
            <span className="sk" style={{ width: '100%', height: '10px' }} />
            <span className="sk" style={{ width: '92%', height: '10px' }} />
            <span className="sk" style={{ width: '96%', height: '10px' }} />
            <span className="sk" style={{ width: '84%', height: '10px' }} />
            <span className="sk" style={{ width: '90%', height: '10px' }} />
            <span className="sk" style={{ width: '60%', height: '10px' }} />
            <span className="sk" style={{ width: '70%', height: '11px', marginTop: 'auto' }} />
          </div>
        ))}
      </section>
    </>
  );
}

// ── AKTUALNOŚCI ──────────────────────────────────────────────────────────────

export function NewsSkeleton() {
  return (
    <>
      <hr style={{ ...HR, marginTop: '-15px' }} />
      <h2 style={{ ...H2_DARK, marginBottom: '-5px', marginTop: '-15px' }}>
        Nasze promocje i aktualności!
      </h2>
      <section
        className="newsSection"
        aria-hidden="true"
        style={{ display: 'flex', alignItems: 'center', maxWidth: '1200px' }}
      >
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="newsSection_panel"
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              border: '1px solid #eee',
              boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
              position: 'relative',
              backgroundColor: 'rgb(250,250,250)',
            }}
          >
            <span className="sk" style={{ width: '100%', height: '170px', borderRadius: 0 }} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%',
                gap: '9px',
                paddingTop: '12px',
              }}
            >
              <span className="sk" style={{ width: '90%', height: '14px' }} />
              <span className="sk" style={{ width: '90%', height: '9px' }} />
              <span className="sk" style={{ width: '82%', height: '9px' }} />
              <span className="sk" style={{ width: '60%', height: '9px' }} />
            </div>
            <span
              className="sk"
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '15px',
                width: '104px',
                height: '26px',
                borderRadius: '20px',
              }}
            />
          </div>
        ))}
      </section>
    </>
  );
}

// ── PLACÓWKI ─────────────────────────────────────────────────────────────────

export function LocationsSkeleton() {
  return (
    <>
      <hr style={HR} />
      <h2 style={{ ...H2_DARK, marginTop: '-25px', marginBottom: '-6px' }}>Nasze placówki</h2>
      <section
        className="locationsSections"
        aria-hidden="true"
        style={{ display: 'flex', alignItems: 'flex-start', maxWidth: '1200px' }}
      >
        {[0, 1, 2].map((col) => (
          <div
            key={col}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              width: 'auto',
            }}
          >
            {Array.from({ length: 8 }).map((_, i) => (
              <p key={i} style={{ fontWeight: 'bold', fontSize: '13px', textAlign: 'left' }}>
                <span
                  className="sk"
                  style={{ width: `${150 + ((i * 37) % 70)}px`, height: '11px' }}
                />
              </p>
            ))}
          </div>
        ))}
      </section>
    </>
  );
}

// ── FAQ ──────────────────────────────────────────────────────────────────────

export function FaqSkeleton() {
  return (
    <>
      <hr style={{ ...HR, marginTop: '-10px' }} />
      <h2 style={{ ...H2_DARK, marginTop: '-30px' }}>Najczęstsze pytania</h2>
      <section
        className="questionSection"
        aria-hidden="true"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '15px',
          maxWidth: '1200px',
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <React.Fragment key={i}>
            {i > 0 ? (
              <hr
                style={{
                  border: '1px solid rgb(0,0,0,0.1)',
                  width: '100%',
                  borderRadius: '20px',
                  marginTop: '-5px',
                }}
              />
            ) : null}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '18px 0',
              }}
            >
              <span
                className="sk"
                style={{ width: `${210 + ((i * 53) % 90)}px`, height: '13px' }}
              />
              <span className="sk" style={{ width: '12px', height: '12px' }} />
            </div>
          </React.Fragment>
        ))}
      </section>
    </>
  );
}